var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "mt-8 mt-md-14",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('div', {
    staticClass: "mb-2 mb-sm-0"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16 font-weight-medium primary--text"
  }, [_vm._v(_vm._s(_vm.label)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pointer,
      expression: "pointer"
    }],
    staticClass: "red--text"
  }, [_vm._v("*")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-16 grey-68--text"
  }, [_vm._t("default")], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }